if (!customElements.get('price-range-slider')) {
  class PriceRangeSlider extends HTMLElement {
    constructor() {
      super();
      this._minPrice = 0;
      this._maxPrice = 100;
      this._minPriceValue = 0;
      this._maxPriceValue = 100;
    }

    // Getters and Setters for prices
    get minPrice() {
      return parseFloat(this.dataset.minPrice) || this._minPrice;
    }

    get maxPrice() {
      return parseFloat(this.dataset.maxPrice) || this._maxPrice;
    }

    get minPriceValue() {
      return parseFloat(this.dataset.minPriceValue) || this._minPriceValue;
    }

    set minPriceValue(value) {
      this._minPriceValue = value;
      this.dataset.minPriceValue = value;
    }

    get maxPriceValue() {
      return parseFloat(this.dataset.maxPriceValue) || this._maxPriceValue;
    }

    set maxPriceValue(value) {
      this._maxPriceValue = value;
      this.dataset.maxPriceValue = value;
    }

    // Querying DOM elements
    get minInput() {
      return this.querySelector('input[name="price_from"]');
    }

    get maxInput() {
      return this.querySelector('input[name="price_to"]');
    }

    get minRange() {
      return this.querySelector('input[type="range"]#FromSlider');
    }

    get maxRange() {
      return this.querySelector('input[type="range"]#ToSlider');
    }

    get minPriceLabel() {
      return this.querySelector('#price_range-min_value_label');
    }

    get maxPriceLabel() {
      return this.querySelector('#price_range-max_value_label');
    }

    connectedCallback() {
      this.updatePriceRange();
      this.addEventListener('input', this.onPriceChange.bind(this));
    }

    updatePriceRange() {
      if (this.minPriceValue > this.maxPriceValue) {
        this.minPriceValue = this.maxPriceValue;
      }
      if (this.maxPriceValue < this.minPriceValue) {
        this.maxPriceValue = this.minPriceValue;
      }

      this.updateInputs();
      this.updateSliders();
      this.updateLabels();
      this.fillSlider();
    }

    updateInputs() {
      this.updateInputAttributes(this.minInput, this.minPriceValue);
      this.updateInputAttributes(this.maxInput, this.maxPriceValue);
    }

    updateInputAttributes(input, value) {
      if (input) {
        input.min = this.minPrice;
        input.max = this.maxPrice;
        input.value = value;
      }
    }

    updateSliders() {
      this.updateSliderAttributes(this.minRange, this.minPriceValue);
      this.updateSliderAttributes(this.maxRange, this.maxPriceValue);
    }

    updateSliderAttributes(slider, value) {
      if (slider) {
        slider.min = this.minPrice;
        slider.max = this.maxPrice;
        slider.value = value;
      }
    }

    updateLabels() {
      if (this.minPriceLabel) this.minPriceLabel.textContent = this.minPrice;
      if (this.maxPriceLabel) this.maxPriceLabel.textContent = this.maxPrice;
    }

    onPriceChange(e) {
      const input = e.target;
      const isMin = input === this.minInput || input === this.minRange;
      const isMax = input === this.maxInput || input === this.maxRange;

      if (!isMin && !isMax) return;

      const rawValue = parseFloat(input.value);
      const clampedToRange = this.clampValue(rawValue);

      if (isMin) {
        const adjusted = Math.min(clampedToRange, this.maxPriceValue);
        this.minPriceValue = adjusted;
        this.minInput.value = adjusted;
        this.minRange.value = adjusted;
      } else if (isMax) {
        const adjusted = Math.max(clampedToRange, this.minPriceValue);
        this.maxPriceValue = adjusted;
        this.maxInput.value = adjusted;
        this.maxRange.value = adjusted;
      }

      this.fillSlider();
    }

    clampValue(value) {
      const parsedValue = parseFloat(value);
      return Math.max(this.minPrice, Math.min(parsedValue, this.maxPrice));
    }

    fillSlider() {
      const rangeDistance = this.maxRange.max - this.maxRange.min;
      const fromPosition = this.minRange.value - this.maxRange.min;
      const toPosition = this.maxRange.value - this.maxRange.min;
      const sliderColor = '#C7C7C7';
      const rangeColor = '#000';

      this.maxRange.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
        ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
        ${sliderColor} 100%)`;

      this.setToggleAccessible();
    }

    setToggleAccessible() {
      this.maxRange.style.zIndex = parseFloat(this.maxRange.value) <= 0 ? 2 : 0;
    }
  }

  customElements.define('price-range-slider', PriceRangeSlider);
}
